export type ModalState = {
    state: "none" | "login",
    loading: boolean
};

export const initState: ModalState = {
    state: "none",
    loading: false
};
